import { Navigate, Route, Routes, useLocation, useParams } from 'react-router';

import { useMaintenanceModeEnabled } from '../../configuration/featureToggle/hooks/useMaintenanceModeEnabled'; // Define routing to sub modules
import { CheckoutContainer } from './checkout/Checkout';
import { MaintenanceView } from './common/MaintenanceView';
import {
    MARKETPLACE_CHECKOUT_PATH,
    MARKETPLACE_CUSTOMER_CENTER_NEW_PATH,
    MARKETPLACE_CUSTOMER_CENTER_PATH,
    MARKETPLACE_PAYMENTS_AUTHENTICATION,
    MARKETPLACE_PRODUCT_DETAILS_PATH,
} from './common/routes';
import { CustomerCenterContainer } from './customerCenter/CustomerCenter';
import { ProductDetailsRedirect } from './openMarketplaceRedirects/ProductDetailsRedirect';
import ReauthenticationPageStripeContainer from './paymentReauthentication/ReauthenticationPageStripeContainer';

const CustomerCenterRedirect = () => {
    const { '*': splat } = useParams();
    const location = useLocation();
    return <Navigate replace to={`/${MARKETPLACE_CUSTOMER_CENTER_NEW_PATH}/${splat || ''}${location.search}`} />;
};

// Define routing to sub modules
const MarketplaceRoutes = () => {
    const maintenanceMode = useMaintenanceModeEnabled();

    return (
        <Routes>
            <Route
                path={`${MARKETPLACE_CUSTOMER_CENTER_PATH}/*`}
                element={maintenanceMode ? <MaintenanceView /> : <CustomerCenterRedirect />}
            />
            <Route
                path={`${MARKETPLACE_CUSTOMER_CENTER_NEW_PATH}/*`}
                element={maintenanceMode ? <MaintenanceView /> : <CustomerCenterContainer />}
            />
            <Route
                path={`${MARKETPLACE_PAYMENTS_AUTHENTICATION}`}
                element={maintenanceMode ? <MaintenanceView /> : <ReauthenticationPageStripeContainer />}
            />
            <Route path={`${MARKETPLACE_PRODUCT_DETAILS_PATH}/*`} element={<ProductDetailsRedirect />} />
            <Route
                path={`${MARKETPLACE_CHECKOUT_PATH}/*`}
                element={maintenanceMode ? <MaintenanceView /> : <CheckoutContainer />}
            />
            <Route path='*' element={<Navigate to={`/${MARKETPLACE_CUSTOMER_CENTER_NEW_PATH}`} />} />
        </Routes>
    );
};

export const MarketplaceContent = MarketplaceRoutes;
